function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import logger, { LapelError } from "../logger";
/*  This logic is needed because we're not using webpack 5 yet */ var sharedExports = {};
var shareExports = function(exports, remote) {
    if (remote === void 0) remote = "";
    /*
  exports is expected to be an object
  {
    "react": ()=> Promise.resolve(()=>require("react"))
  }

  The value should be:
  - a function that returns a promise
  - that promise should resolve to a function
  - that function should return the module
  */ // if no remote is given "" is used and that will apply to all remote entries
    // This method is additive, there is no "unshare"
    sharedExports[remote] = Object.assign(sharedExports[remote] || {}, exports);
};
var applySharedExports = function(remote) {
    var _sharedExports, _sharedExports1, _window_remote, _window, _window_remote1, _window1, _window_remote2, _window2, _window_remote3, _window3;
    if (typeof window === "undefined") {
        return null;
    }
    // Given a remote entry, we gather all the modules that the host application has already
    var mergedExports = _extends({}, (_sharedExports = sharedExports) == null ? void 0 : _sharedExports[""], (_sharedExports1 = sharedExports) == null ? void 0 : _sharedExports1[remote]);
    // Logic for applying @zackjackson @leonardmeagher
    // check if using new webpack API
    var override = ((_window = window) == null ? void 0 : (_window_remote = _window[remote]) == null ? void 0 : _window_remote.init) ? (_window1 = window) == null ? void 0 : (_window_remote1 = _window1[remote]) == null ? void 0 : _window_remote1.init : (_window2 = window) == null ? void 0 : (_window_remote2 = _window2[remote]) == null ? void 0 : _window_remote2.override;
    if ((_window3 = window) == null ? void 0 : (_window_remote3 = _window3[remote]) == null ? void 0 : _window_remote3.init) {
        Object.assign(mergedExports, Object.entries(mergedExports).reduce(function(acc, param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            if (typeof value === "function") {
                var version = "0.0.0";
                try {
                    // eslint-disable-next-line
                    version = value.version;
                } catch (error) {
                    logger.debug(new LapelError("Error retrieving shared version", {
                        cause: error
                    }));
                }
                Object.assign(acc, _define_property({}, key, _define_property({}, version, {
                    get: value,
                    loaded: true
                })));
            }
            return acc;
        }, {}));
    }
    if (override) {
        try {
            return override(mergedExports);
        } catch (error) {
            logger.warn(new LapelError(error.message + " while trying to apply webpack 5 shim of shared exports to " + remote, {
                cause: error
            }), {
                tags: {
                    functionName: "applySharedExports"
                },
                fingerprint: [
                    "applySharedExports",
                    remote
                ]
            }, function(scope) {
                scope.setTag("remote", remote);
            });
        }
    }
    return null;
};
export { shareExports, applySharedExports };

//# sourceMappingURL=WebPack5Shim.js.map